class BlockMap{

	constructor(){

		let blockMaps = document.querySelectorAll('.map-inner');

		if( !blockMaps ){
			return;
		}

		blockMaps.forEach( (blockMap) => {
			let markers = blockMap.querySelectorAll('.map-marker');

			if( blockMap.dataset.type === "static" ){

				mapMaker.createStaticMap( blockMap, markers );

			}else{

				let map = mapMaker.createDynamicMap( blockMap );

				if( blockMap.dataset.zoom ){
					map.setZoom( parseInt(blockMap.dataset.zoom) );
				}

				markers.forEach( (m) => {
					mapMaker.createMarker(m, map);
				});

				if( blockMap.dataset.markerRelationship !== "" ){
					mapMaker.markerRelationShip(map, blockMap.dataset.markerRelationship);
				}

				if( map.markers.length > 1 ){
					map.fitBounds(map.bounds);
				}else{
					map.setCenter(map.markers[0].getPosition());
				}

				if( blockMap.dataset.markerClusterer === "true" ){
					mapMaker.initMarkerClusterer(map);
				}

			}
		});

	}

}